import React from "react";
import { Route, Redirect } from "react-router-dom";
import * as AuthService from "../services/Auth";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  //console.log(" AuthService.isAuthenticated()",  AuthService.isAuthenticated());
  return (
    <Route
      {...rest}
      render={props =>
        AuthService.isAuthenticated() === true ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

export default ProtectedRoute;
